.c{justify-content:center;}